import { render, staticRenderFns } from "./PayPage.vue?vue&type=template&id=c80c4c54&scoped=true"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"
import style0 from "./PayPage.vue?vue&type=style&index=0&id=c80c4c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c4c54",
  null
  
)

export default component.exports